import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Result, Spin } from "antd";
import { vnPayResult } from "../../../../../service/payment";
import { learningCourseStore } from "../../../../../stores/stores";
import { getStartLearningCourse } from "../../../../../service/my-course/my-course-service";
import { routesConfig } from "../../../../../config/routes";

const VNPayResultPage = () => {
	const [searchParams] = useSearchParams();
	const [status, setStatus] = useState<"pending" | "success" | "fail">("pending");
	const { setTab } = learningCourseStore();
	const [courseId, setCourseId] = useState<number>(0)
	const navigate = useNavigate()
	useEffect(() => {
		const verifyResult = async () => {
			const query = Object.fromEntries(searchParams.entries());
			const rawPayDate = query?.vnp_PayDate || "";
			const payDate = new Date(
				`${rawPayDate.slice(0, 4)}-${rawPayDate.slice(4, 6)}-${rawPayDate.slice(6, 8)}T${rawPayDate.slice(8, 10)}:${rawPayDate.slice(10, 12)}:${rawPayDate.slice(12, 14)}Z`
			);

			const payload = {
				transactionId: localStorage.getItem("vnPay_transactionId"),
				amount: Number(query?.vnp_Amount || 0),
				bankCode: query?.vnp_BankCode || "",
				bankTransactionNo: query?.vnp_BankTranNo || "",
				cardType: query?.vnp_CardType || "",
				orderInfo: query?.vnp_OrderInfo || "",
				payDate,
				responseCode: query?.vnp_ResponseCode || "",
				transactionNo: query?.vnp_TransactionNo || "",
				transactionStatus: query?.vnp_TransactionStatus || "",
				txnRef: query?.vnp_TxnRef || "",
			};

			try {
				const res = await vnPayResult(payload);
				if (res.data.success) {
					setStatus("success");
					setCourseId(res?.data.data.courseId)
				} else {
					setStatus("fail");
				}
			} catch (err) {
				setStatus("fail");
			}
		};

		verifyResult();
	}, [searchParams]);

	if (status === "pending") return <div className="m-auto">
		<Spin tip="Đang xác minh giao dịch..." />
	</div>;

	const startLearningCourse = async () => {
		setTab("1");
		try {
			getStartLearningCourse(Number(courseId));
			navigate(`${routesConfig.learningCourseStructure}/${courseId}`);
		} catch (error) { }

	};

	return status === "success" ? (
		<Result
			status="success"
			title="Thanh toán thành công!"
			subTitle="Cảm ơn bạn đã đăng ký khoá học."
			className="m-auto"
			extra={[
				<Button
					className="btn-primary h-40 flex-1 w-full-100"
					onClick={startLearningCourse}
				>
					Bắt đầu học
				</Button>
			]}
		/>
	) : (
		<Result
			status="error"
			title="Thanh toán thất bại"
			subTitle="Có lỗi xảy ra hoặc giao dịch đã bị huỷ."
			className="m-auto"

		/>
	);
};

export default VNPayResultPage;
